import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>MY Skills</h5>
      <h2>My Experience</h2>

      <div className='container experience__container'>
        <div className='frontend'>
         <h3>Frontend Development</h3>
         <div className='experience__content'>
          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>HTML</h4>
           <small className='text-light'>Experienced</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>CSS</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Javascript</h4>
           <small className='text-light'>Experienced</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Bootstrap</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Tailwind</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>REACT</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

         </div>
        </div>

        {/* BACKEND */}
        <div className='backend'>
        <h3>Backend Development</h3>
         <div className='experience__content'>
          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Node JS</h4>
           <small className='text-light'>Experienced</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Express JS</h4>
           <small className='text-light'>Experienced</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>MongoDB</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>RESTful APIs</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Typescript</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Testing</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

          <article className='experience__details'>
           <BsPatchCheckFill className='experience__details-icon'/>
           <div>
           <h4>Version Control</h4>
           <small className='text-light'>Intermediate</small>
           </div>
          </article>

         </div>
        </div>
      </div>
    </section>
  )
}

export default Experience